import localizationEng from '../../data/localization/languages/english';
import localizationSv from '../../data/localization/languages/swedish';
import React from 'react';
import styles from './noSupportBrowser.css';
import Arrow from 'assets/img/arrow.png';

/***********************************************************************************************************************
 *click_the_three_dots, open_in_your_browser
 **********************************************************************************************************************/
const NoSupportedBrowser = () => {
    const isSwedishLocale = [...navigator.languages].some(lang => lang.includes('sv')) || navigator.language.includes('sv');
    const localization = isSwedishLocale ? localizationSv : localizationEng;
    const ua = navigator.userAgent || navigator.vendor || window.opera;
    const isFaceBookAppRun = (ua.indexOf('FBAN') > -1) || (ua.indexOf('FBAV') > -1) || (ua.indexOf('FBIOS') > -1);

    return isFaceBookAppRun ?
        <div className={styles.wrapper}>

            <div className={styles.containersWrap}>

                <div className={styles.informationContainer}>

                    <div className={styles.topTextWrap}>

                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                            <path fill-rule="evenodd"
                                  d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM11 8C11 7.44772 11.4477 7 12 7C12.5523 7 13 7.44772 13 8V12C13 12.5523 12.5523 13 12 13C11.4477 13 11 12.5523 11 12V8ZM13 16C13 16.5523 12.5523 17 12 17C11.4477 17 11 16.5523 11 16C11 15.4477 11.4477 15 12 15C12.5523 15 13 15.4477 13 16Z"
                                  clip-rule="evenodd"/>
                        </svg>
                        <h3>
                            {localization.play_the_quiz_in_your_browser}
                        </h3>
                    </div>
                    <div className={styles.middleTextWrap}>
                        <ul>
                            <li/>
                            <li/>
                            <li/>
                        </ul>
                    </div>
                    <div className={styles.bottomTextWrap}>
                        <h3>
                            {localization.click_the_three_dots}
                            {'\n'}
                            {localization.above_or_down}
                        </h3>
                        <h3>
                        <span>"
                            {localization.open_in_your_browser}".
                        </span>
                        </h3>
                    </div>

                </div>
                <div className={styles.arrowContainer}>
                    <img alt={''}
                         style={{
                             transform: 'rotateZ(360deg)'
                         }}
                         src={Arrow}/>
                    <img alt={''}
                         style={{
                             transform: 'rotateX(180deg)'
                         }}
                         src={Arrow}/>

                </div>

            </div>
        </div> :
        <div className={styles.unSupportWrapper}>
            <h3>
                {localization.old_browser_version}
            </h3>
            <h3>
                {localization.browser_not_supported}
            </h3>
        </div>;
};
export default NoSupportedBrowser;